import {
  Badge,
  Divider,
  Dropdown,
  Empty,
  Input,
  Modal,
  Spin,
  Tag,
  Tooltip,
} from 'antd'

import Avatar from 'components/Avatar'
import Button from 'components/Button'
import Drawer from 'components/Drawer'
import Flex from 'components/Flex'
import Pagination from 'components/Pagination'
import NoInterview from 'components/icons/NoInterview.png'
import EvaluationForm from 'modules/ATS/Components/EvaluationForm.js'
import { FooterFlex } from 'modules/Students/Partials/StudentsBulkUpload/Style/style'
import {
  OtherFlex,
  SecondGreyText,
  SubFLex,
} from 'modules/Students/Partials/StudentsInfoTable/ViewStudentDrawer/Partials/StudentDrawerContent/Style/style'
import {
  CollegeName,
  HeaderFlexOne,
  InfoSection,
  StudentName,
} from 'modules/Students/Partials/StudentsInfoTable/ViewStudentDrawer/style'
import { EmptyWrapper } from 'modules/Users/Style/style'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { StyledTableSqare } from '../../../../components/TableStyles/TableStylesSqare/TableStylesSqare'
import ArchiveIcon from '../../../../components/icons/ArchiveIcon'
import CopyFileIcon from '../../../../components/icons/JobRoleIcons/CopyFileIcon'
import EditPenIcon from '../../../../components/icons/JobRoleIcons/EditPenIcon'
import EvaluationScheduleIconBlue from '../../../../components/icons/JobRoleIcons/Evaluation Schedule'
import EvaluationScheduleIconOne from '../../../../components/icons/JobRoleIcons/EvaluationScheduleOne'
import TableTag from '../Components/TableTag'

import { EmptyDivElement } from '../../../../components/UIComponents/CommonStyledComponent'
import { COLORS } from '../../../../theme'
import SuccessMessage from '../../../../utils/SuccessMessage'
import { FolderSpinner } from '../../../Placement/style'
import TableJobRoleStatus from '../Components/JobRoleStatus'

const StyledTableContainer = styled.div`
  height: 400px;
`
const CustomTagBlue = styled(Tag)`
  background-color: rgba(50, 73, 215, 1);
  border-radius: 20px;
  font-size: 10px;
  height: 20px;
  width: max-content;
`
const CustomTagBlack = styled(Tag)`
  background-color: rgba(0, 0, 0, 1);
  border-radius: 20px;
  width: max-content;
  font-size: 10px;
  height: 20px;
`

const InnerContainerFlex = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  margin-left: 5px;
`

const IconContainer = styled.div`
  display: flex;
  gap: 5px;
  flex-direction: column;
  justify-content: 'spaceBetween';
`

const Card = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 13px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  height: ${props => (props?.height ? props?.height : '')} !important;
  overflow-y: ${props => (props?.scroll ? 'scroll' : '')} !important;
`
const CalanderContainer = styled.div`
  display: flex;
  gap: 12px;
  flex-direction: row;
  justify-content: 'spaceBetween';
  vertical-align: baseline;
  align-items: center;
`
const ButtonContainer = styled.div`
  display: flex;
  gap: 40px;
  flex-direction: row;
  margin-top: 10px;
  align-items: end;
  justify-content: end;
`

const CustomInput = styled(Input)`
  width: 150px;
  padding: 10px;
  min-width: auto;
  border: 3px solid #cccfd6;
  border-radius: 8px;
  text-align: center;
  font-size: 16px;
  margin-top: 10px;
`
const CardText = styled.p`
  display: flex;
  width: 100%;
  white-space: nowrap;
  font-weight: 600;
  margin-bottom: 0px;
  ${''}
`

const LeftAlignedTooltip = styled(Tooltip)`
  .ant-tooltip-inner {
    text-align: left;
    display: flex;
    align-items: center;
  }
`
const { confirm } = Modal
const Table = ({
  data,
  setSortBy,
  sortBy,
  setPageNum,
  pageNum,
  ScrollRef,
  fetchJobRoles,
  totalPages,
  loading,
  setLoading,
  addNewRound,
  roundData,
  updateNewRound,
  updateRoundData,
  getPreviewData,
  getCorporateData,
  getInstituteData,
  instituteCampusId,
  page,
  searchValue,
  duplicateRole,
  setIsDuplicated,
  selectedCategory,
  state,
  handleEditRole,
  archiveJobRole,
  unarchiveJobRole,
}) => {
  const [popoverVisibility, setPopoverVisibility] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const handlePopoverVisibleChange = (index, visible) => {
    const updatedVisibility = [...popoverVisibility]
    updatedVisibility[index] = visible
    setPopoverVisibility(updatedVisibility)
  }
  const menu = (menuData, rounds) => {
    return (
      <Card
        height={data?.length <= 1 ? '124px' : ''}
        scroll={data?.length <= 1}
      >
        {rounds?.length &&
          rounds?.map((round, i) => (
            <CalanderContainer key={i + 'round'}>
              <Tooltip title={` ${round?.name}`}>
                <CardText
                  style={{
                    textWrap: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    textTransform: 'initial',
                    display:
                      menuData?.role_published_by === 'CORPORATE'
                        ? 'block'
                        : 'flex',
                    width: '115px',
                    padding: '10px',
                    textAlign: 'left',
                  }}
                >
                  {round?.name}
                </CardText>
              </Tooltip>
              {menuData?.role_published_by === 'CORPORATE' ? null : (
                <>
                  <CustomInput
                    disabled
                    placeholder={
                      round?.endDate === '' || round?.endDate === undefined
                        ? 'No Time found'
                        : moment(round?.startDate).format('DD MMM, YYYY')
                    }
                    style={{ fontWeight: 'bold' }}
                  />
                  &nbsp;&nbsp;-&nbsp;&nbsp;
                  <CustomInput
                    disabled
                    placeholder={
                      round?.endDate === '' || round?.endDate === undefined
                        ? 'No Time found'
                        : moment(round?.endDate).format('DD MMM, YYYY')
                    }
                    style={{ fontWeight: 'bold' }}
                  />
                </>
              )}
            </CalanderContainer>
          ))}
        <ButtonContainer>
          <Button.Secondary
            text="View Drive"
            onClick={e => atsNavigate(e, menuData)}
            style={{ width: '150px' }}
          />
          {menuData?.role_published_by !== 'CORPORATE' && (
            <Button.Primary
              text="Schedule Drive"
              onClick={e => atsNavigate(e, menuData, true)}
              style={{ width: '150px' }}
            />
          )}
        </ButtonContainer>
      </Card>
    )
  }

  const navigate = useNavigate()
  const atsNavigate = (e, data, forSchedule) => {
    let schedule = forSchedule ? `&schedule=${forSchedule}` : ''
    e.preventDefault()
    navigate(
      `/jobRoles/ats/${data.id}?stage=all_candidates&jobType=${data.tittle}&publishedBy=${data.role_published_by}${schedule}`
    )
  }

  const atsDrawerNavigate = (e, data) => {
    e.preventDefault()
    navigate(
      `/jobRoles/ats/${data.id}?stage=all_candidates&jobType=${data.tittle}&publishedBy=${data.rolePublishedBy}`
    )
  }

  const jobPreviewNavigate = (e, data, key = 'applied') => {
    e.preventDefault()
    let query = `?selectedCategory=${selectedCategory}`
    let filter = `${query}&q=${key.toUpperCase()}`

    navigate(`/jobRoles/jobPreview/${data.id}${filter}`)
  }
  const [openDrawer, setOpenDrawer] = useState(false)
  const [openCompanyDrawer, setOpenCompanyDrawer] = useState(false)
  const [sortedItems, setSortedItems] = useState([])
  const [save, setSave] = useState(false)
  const [id, setId] = useState('')
  const [instituteData, setInstituteData] = useState('')
  const [corporateData, setCorporateData] = useState('')
  const [roundValues, setRoundValues] = useState({
    roundName: '',
    roundNameError: '',
    interviewType: '',
    interviewTypeError: '',
    assessmentType: '',
    assessmentTypeError: '',
    roundDescription: '',
    roundDescriptionError: '',
    faceToFaceType: '',
    faceToFaceTypeError: '',
    startDateError: '',
    endDateError: '',
    startDate: null,
    endDate: null,
    id: '',
  })
  useEffect(() => {
    if (openDrawer) {
      setRoundValues({
        roundName: '',
        roundNameError: '',
        interviewType: '',
        interviewTypeError: '',
        assessmentType: '',
        assessmentTypeError: '',
        roundDescription: '',
        roundDescriptionError: '',
        faceToFaceType: '',
        faceToFaceTypeError: '',
        startDateError: '',
        endDateError: '',
        startDate: null,
        endDate: null,
        id: '',
      })
    }
  }, [openDrawer])

  const fetchCorporateData = async corporateId => {
    try {
      setIsLoading(true)
      const corporateList = await getCorporateData(
        corporateId,
        instituteCampusId
      )
      setCorporateData(corporateList)
      setLoading(false)
    } catch (error) {
      ErrorMessage('Error fetching roles, Try again .')
      setLoading(false)
    } finally {
      setIsLoading(false)
    }
  }
  const fetchInstituteData = async (instituteCampusId, instituteCompanyId) => {
    try {
      setIsLoading(true)
      const corporateList = await getInstituteData(
        instituteCampusId,
        instituteCompanyId
      )
      setInstituteData(corporateList)
      setLoading(false)
    } catch (error) {
      ErrorMessage('Error fetching roles, Try again .')
      setLoading(false)
    } finally {
      setIsLoading(false)
    }
  }
  const combinedJobRoles = [
    ...(corporateData?.jobRoles || []).map(item => ({
      ...item,
      source: 'corporate',
    })),
    ...(instituteData?.jobRoles || []).map(item => ({
      ...item,
      source: 'institute',
    })),
  ]

  const content = () => {
    return (
      <>
        {openDrawer && (
          <EvaluationForm
            updateNewRound={updateNewRound}
            addNewRound={addNewRound}
            roundData={roundData}
            updateRoundData={updateRoundData}
            sortedItems={sortedItems}
            setSortedItems={setSortedItems}
            save={save}
            setSave={setSave}
            openDrawer={openDrawer}
            setRoundValues={setRoundValues}
            roundValues={roundValues}
            atsParam={id}
          />
        )}

        {openCompanyDrawer && (
          <>
            {isLoading ? (
              <FolderSpinner>
                <Spin />
              </FolderSpinner>
            ) : (
              <>
                {(corporateData || instituteData) && (
                  <>
                    <HeaderFlexOne spaceBetween>
                      <Flex>
                        <Avatar
                          background
                          src={corporateData?.logo || instituteData?.logo?.url}
                          size={90}
                          IconName={instituteData?.companyName?.split('')[0]}
                          font={18}
                          shape="square"
                        />
                        <InfoSection column center>
                          <StudentName>
                            {corporateData?.name || instituteData?.companyName}
                          </StudentName>
                          <CollegeName>
                            {corporateData?.industry || instituteData?.industry}
                          </CollegeName>
                        </InfoSection>
                      </Flex>
                    </HeaderFlexOne>
                    <SubFLex column gap="20px" paddingTop="50px">
                      <SubFLex>
                        <OtherFlex spaceBetween width="50%">
                          <SecondGreyText
                            color={COLORS.GREY_T_60}
                            marginLeft="10px"
                          >
                            Company POC
                          </SecondGreyText>
                        </OtherFlex>
                        <OtherFlex width="100%">
                          <SecondGreyText>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: instituteData?.contactDetails?.[0]
                                  ?.pocName
                                  ? instituteData?.contactDetails?.[0]?.pocName
                                  : corporateData?.admin?.first_name
                                  ? '-'
                                  : '-',
                              }}
                            ></div>
                          </SecondGreyText>
                        </OtherFlex>
                      </SubFLex>

                      <SubFLex>
                        <OtherFlex spaceBetween width="50%">
                          <SecondGreyText
                            color={COLORS.GREY_T_60}
                            marginLeft="10px"
                          >
                            Contact Details
                          </SecondGreyText>
                        </OtherFlex>
                        <OtherFlex width="100%">
                          <SecondGreyText>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: instituteData?.contactDetails?.[0]
                                  ?.pocNumber
                                  ? instituteData?.contactDetails?.[0]
                                      ?.pocNumber
                                  : corporateData?.contactNumber?.length
                                  ? '-'
                                  : '-',
                              }}
                            ></div>
                          </SecondGreyText>
                        </OtherFlex>
                      </SubFLex>
                      <SubFLex>
                        <OtherFlex spaceBetween width="50%">
                          <SecondGreyText
                            color={COLORS.GREY_T_60}
                            marginLeft="10px"
                          >
                            Company Website
                          </SecondGreyText>
                        </OtherFlex>
                        <OtherFlex width="100%">
                          <SecondGreyText>
                            <div
                              style={{ wordBreak: 'break-all' }}
                              dangerouslySetInnerHTML={{
                                __html: instituteData?.website?.length
                                  ? instituteData?.website
                                  : corporateData?.website?.length
                                  ? corporateData?.website
                                  : '-',
                              }}
                            ></div>
                          </SecondGreyText>
                        </OtherFlex>
                      </SubFLex>
                      <SubFLex>
                        <OtherFlex spaceBetween width="50%">
                          <SecondGreyText
                            color={COLORS.GREY_T_60}
                            marginLeft="10px"
                          >
                            Company Sector
                          </SecondGreyText>
                        </OtherFlex>
                        <OtherFlex width="100%">
                          <SecondGreyText>
                            <div
                              style={{ wordBreak: 'break-all' }}
                              dangerouslySetInnerHTML={{
                                __html: instituteData?.sector
                                  ? instituteData?.sector
                                  : corporateData?.sector
                                  ? corporateData?.sector
                                  : '-',
                              }}
                            ></div>
                          </SecondGreyText>
                        </OtherFlex>
                      </SubFLex>
                      <SubFLex>
                        <OtherFlex spaceBetween width="50%">
                          <SecondGreyText
                            color={COLORS.GREY_T_60}
                            marginLeft="10px"
                          >
                            Company Description
                          </SecondGreyText>
                        </OtherFlex>
                        <OtherFlex width="100%">
                          <SecondGreyText>
                            <div
                              style={{ wordBreak: 'break-all' }}
                              dangerouslySetInnerHTML={{
                                __html: instituteData?.description?.length
                                  ? instituteData?.description
                                  : corporateData?.longDescription?.length
                                  ? corporateData?.longDescription
                                  : '-',
                              }}
                            ></div>
                          </SecondGreyText>
                        </OtherFlex>
                      </SubFLex>
                    </SubFLex>

                    <Divider style={{ borderWidth: '2px' }} />

                    <SubFLex>
                      <OtherFlex spaceBetween width="30%">
                        <SecondGreyText
                          color={COLORS.GREY_T_60}
                          marginLeft="10px"
                        >
                          {'Roles floated'}
                        </SecondGreyText>
                      </OtherFlex>
                      <SubFLex flexDirection="column">
                        {!combinedJobRoles?.length ? (
                          <EmptyWrapper center>
                            <Empty
                              imageStyle={{ height: 80 }}
                              description={
                                <span>No Active Job Role Available</span>
                              }
                            />
                          </EmptyWrapper>
                        ) : (
                          combinedJobRoles.map((item, key) => (
                            <SubFLex key={key + 'title'} flexWrap gap="10px">
                              <SecondGreyText
                                color="blue"
                                pointer
                                onClick={e => atsDrawerNavigate(e, item)}
                              >
                                {item.tittle}
                              </SecondGreyText>
                            </SubFLex>
                          ))
                        )}
                      </SubFLex>
                    </SubFLex>
                  </>
                )}{' '}
              </>
            )}
          </>
        )}
      </>
    )
  }

  const footer = () => {
    return (
      <FooterFlex right>
        {openDrawer && (
          <>
            <Button.Secondary
              text="Cancel"
              onClick={() => {
                setOpenDrawer(false)
                setId('')
              }}
            />
            <Button.Primary
              htmlType="submit"
              form="bulkUpload"
              text="Save"
              onClick={() => {
                setSave(true)
                setOpenDrawer(false)
              }}
            />
          </>
        )}

        {openCompanyDrawer && (
          <Button.Secondary
            text="Close"
            onClick={() => {
              setOpenCompanyDrawer(false)
              setId('')
            }}
          />
        )}
      </FooterFlex>
    )
  }
  const handleDuplicateRole = data => {
    confirm({
      title: 'Duplicate Role?',
      okText: 'Confirm',
      okType: 'primary',
      cancelText: 'Cancel',
      onOk: async () => {
        try {
          const response = await duplicateRole(
            data.id,
            data.company_id,
            instituteCampusId
          )

          if (response?.status == 200) {
            SuccessMessage('Duplicated successfully!')
            setIsDuplicated(true)
            ScrollRef()
          }
        } catch (error) {}
      },
    })
  }

  const handleArchiveRole = jobId => {
    confirm({
      title: 'Archive this role?',
      content:
        'It will be hidden from the Roles list, Dashboard, and exports. You can restore it from the Archive tab.',
      okText: 'Archive',
      okType: 'primary',
      cancelText: 'Cancel',
      onOk: async () => {
        try {
          await archiveJobRole(instituteCampusId, jobId)
          fetchJobRoles({ pageNum, sortBy })
        } catch (error) {
          console.error('Error archiving role:', error)
        }
      },
    })
  }

  const handleUnarchiveRole = jobId => {
    confirm({
      title: 'Restore this role?',
      content:
        'It will be moved back into the active Roles list and show up in the Dashboard and exports.',
      okText: 'Restore',
      okType: 'primary',
      cancelText: 'Cancel',
      onOk: async () => {
        try {
          await unarchiveJobRole(instituteCampusId, jobId)
          fetchJobRoles({ pageNum, sortBy })
        } catch (error) {
          console.error('Error restoring role:', error)
        }
      },
    })
  }

  const handleDrawerClick = data => {
    setOpenCompanyDrawer(true)
    if (data?.role_published_by === 'INSTITUTE') {
      const newId = data?.company_id
      setId(newId)
      fetchInstituteData(instituteCampusId, newId)
    } else if (data?.role_published_by === 'CORPORATE') {
      const newId = data?.corporate_id
      setId(newId)
      fetchCorporateData(newId)
    }
  }
  const CaptilizeLetter = text => {
    return text
      ?.split('_')
      ?.map(
        word => word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase()
      )
      ?.join('_')
  }

  const dataLength = data.length
  const columns = [
    {
      title: 'Role',
      dataIndex: 'tittle',
      key: 'role',
      align: 'left',
      width: 230,
      sorter: true,

      fixed: 'left',
      sortDirections: ['ascend', 'descend'],
      render: (text, data) => (
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <div style={{ display: 'flex', gap: '5px',     textWrap: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis', }}>
           <TableTag
              Corp={data?.role_published_by == 'CORPORATE'}
              Extnl={data?.externallink}
            />
          <Tooltip title={` ${CaptilizeLetter(text)}`}>
            <a
              style={{
                color: 'rgba(50, 73, 215, 1)',
                textWrap: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
              onClick={e => jobPreviewNavigate(e, data)}
              href="/"
            >
              {CaptilizeLetter(text)}
            </a>
          </Tooltip>
          </div>
          <InnerContainerFlex>
            <Tooltip title="Duplicate">
              <EmptyDivElement
                onClick={() => handleDuplicateRole(data)}
                style={{ cursor: 'pointer' }}
              >
                {data?.role_published_by == 'INSTITUTE' && <CopyFileIcon />}
              </EmptyDivElement>
            </Tooltip>
            {data?.role_published_by == 'INSTITUTE' &&
              (data?.isArchived ? (
                <Tooltip title="Restore role">
                  <EmptyDivElement
                    onClick={() => handleUnarchiveRole(data.id)}
                    style={{ cursor: 'pointer' }}
                  >
                    <ArchiveIcon
                      color="rgba(50, 73, 215, 1)"
                      width={20}
                      height={20}
                    />
                  </EmptyDivElement>
                </Tooltip>
              ) : (
                <Tooltip
                  title={
                    data?.canArchive
                      ? 'Archive this role'
                      : "Can't archive — students have already applied"
                  }
                >
                  <EmptyDivElement
                    onClick={() =>
                      data?.canArchive && handleArchiveRole(data.id)
                    }
                    style={{
                      cursor: data?.canArchive ? 'pointer' : 'not-allowed',
                      opacity: data?.canArchive ? 1 : 0.4,
                    }}
                  >
                    <ArchiveIcon width={20} height={20} />
                  </EmptyDivElement>
                </Tooltip>
              ))}
          </InnerContainerFlex>
        </div>
      ),
    },
    {
      title: 'Company',
      dataIndex: 'company_name',
      sorter: true,
      key: 'company',
      align: 'left',
      width: 180,
      sortDirections: ['ascend', 'descend'],
      hidden: true,
      render: (text, data) => (
        <Tooltip title={` ${text}`} onClick={() => handleDrawerClick(data)}>
          <a
            style={{ color: 'rgba(50, 73, 215, 1)' }}
            href="/"
            onClick={e => e.preventDefault()}
          >
            {CaptilizeLetter(text)}
          </a>
        </Tooltip>
      ),
    },

    {
      title: 'Eligible Students',
      dataIndex: 'eligibleCandidates',
      sorter: true,
      key: 'eligibleCandidates',
      align: 'center',
      width: 100,

      render: (text, data) => (
        <a
          style={{ color: 'rgba(50, 73, 215, 1)' }}
          onClick={e => jobPreviewNavigate(e, data, 'eligible')}
          href="/"
        >
          {text}
        </a>
      ),
      sortDirections: ['ascend', 'descend'],
      className: 'Eligible-students',
    },

    // ...(selectedCategory === 'PLACEMENT'
    //   ? [
    //       {
    //         title: 'Eligibile (Restricted)',
    //         dataIndex: 'restrictedCandidates',
    //         sorter: true,
    //         key: 'restrictedCandidates',
    //         align: 'center',
    //         width: 100,
    //         render: (text, data) => (
    //           <a
    //             style={{ color: 'rgba(50, 73, 215, 1)' }}
    //             onClick={e => jobPreviewNavigate(e, data, 'restricted')}
    //             href="/"
    //           >
    //             {text}
    //           </a>
    //         ),
    //         sortDirections: ['ascend', 'descend'],
    //         className: 'Restricted-Students',
    //       },
    //     ]
    //   : []),

    {
      title: ' Ineligible Students',
      dataIndex: 'inEligibleCandidates',
      sorter: true,
      key: 'inEligibleCandidates',
      align: 'center',
      width: 105,

      render: (text, data) => (
        <a
          style={{ color: 'rgba(50, 73, 215, 1)' }}
          onClick={e => jobPreviewNavigate(e, data, 'inEligible')}
          href="/"
        >
          {text}
        </a>
      ),
      sortDirections: ['ascend', 'descend'],
      className: 'Ineligible-students',
    },

    {
      title: 'Applied Students',
      dataIndex: 'appliedCandidates',
      sorter: true,
      key: 'appliedCandidates',
      align: 'center',
      width: 100,

      render: (text, data) => (
        <a
          style={{ color: 'rgba(50, 73, 215, 1)' }}
          onClick={e => jobPreviewNavigate(e, data, 'applied')}
          href="/"
        >
          {text}
        </a>
      ),
      sortDirections: ['ascend', 'descend'],
      className: 'Applied-Students',
    },

    {
      title: ' Not applied students',
      dataIndex: 'notAppliedCandidates',
      sorter: true,
      render: (text, data) => (
        <a
          style={{ color: 'rgba(50, 73, 215, 1)' }}
          onClick={e => jobPreviewNavigate(e, data, 'missed')}
          href="/"
        >
          {text}
        </a>
      ),
      key: 'notAppliedCandidates',
      align: 'center',
      width: 100,
      sortDirections: ['ascend', 'descend'],
      className: 'Not-Applied-students',
    },

    {
      title: 'Placed students ',
      dataIndex: 'placedCandidates',
      render: (text, data) => (
        <a
          style={{ color: 'rgba(50, 73, 215, 1)' }}
          onClick={e => jobPreviewNavigate(e, data, 'placed')}
          href="/"
        >
          {text}
        </a>
      ),
      sorter: true,
      key: 'placedCandidates',
      align: 'center',
      width: 100,
      className: 'Placed-students',
    },

    {
      title: 'CTC range (LPA)',
      dataIndex: 'CTCrangeLPA',
      sorter: true,
      key: 'ctc',
      width: 120,

      render: (value, data, index) => {
        return (
          <div>
            {(data?.min_compensation / 100000).toFixed(1) ==
            (data?.max_compensation / 100000).toFixed(1) ? (
              (data?.max_compensation / 100000).toFixed(1)
            ) : (
              <>
                {(data?.min_compensation / 100000).toFixed(1)} -{' '}
                {(data?.max_compensation / 100000).toFixed(1)}
              </>
            )}
          </div>
        )
      },
      align: 'center',
      sortDirections: ['ascend', 'descend'],
    },

    {
      title: 'Evaluation Schedule',
      dataIndex: 'interviewworkflow',
      key: 'interviewworkflow',
      align: 'center',
      width: 120,
      sortDirections: ['ascend', 'descend'],
      render: (value, data, index) => (
        <div
          style={{
            display: 'flex',
            marginLeft: '20px',
            justifyContent: 'center',
            gap: '5px',
            cursor: 'pointer',
          }}
        >
          {value?.rounds?.length > 0 ? (
            <>
              <Dropdown
                placement="bottom"
                overlay={menu(data, value?.rounds)}
                trigger={['click']}
                visible={popoverVisibility[index]}
                id="filterDropdown"
                getPopupContainer={
                  dataLength > 3
                    ? trigger => trigger.parentNode
                    : () =>
                        document.getElementsByClassName('ant-table-wrapper')[0]
                }
                onVisibleChange={visible =>
                  handlePopoverVisibleChange(index, visible)
                }
              >
                <EmptyDivElement
                  onClick={() => setPopoverVisibility(popoverVisibility[index])}
                >
                  <EvaluationScheduleIconBlue />
                </EmptyDivElement>
              </Dropdown>

              <Badge
                count={value?.rounds?.length}
                style={{
                  cursor: 'pointer',
                  marginTop: '.1em',
                  background: 'rgba(50, 73, 215, 1)',
                }}
              />
            </>
          ) : (
            <Dropdown
              placement="bottom"
              overlay={menu(data)}
              trigger={['click']}
              visible={popoverVisibility[index]}
              id="filterDropdown"
              getPopupContainer={trigger => trigger.parentNode}
              onVisibleChange={visible =>
                handlePopoverVisibleChange(index, visible)
              }
            >
              <EvaluationScheduleIconOne />
            </Dropdown>
          )}
        </div>
      ),
    },

    {
      title: 'Status',
      dataIndex: 'role_status',
      sorter: false,
      key: 'status',
      align: 'left',
      render: (role_status, data) => (
        <TableJobRoleStatus status={role_status} />
      ),
      width: 140,
      sortDirections: ['ascend', 'descend'],
    },
  ]
  const onPageChange = pageNum => {
    setLoading(true)
    ScrollRef()
    let pageNo = pageNum - 1
    setPageNum(pageNo)
    if(searchValue?.length > 0){
      fetchJobRoles({ pageNum: pageNo, sortBy: sortBy, searchValue: searchValue })
    }else{

      fetchJobRoles({ pageNum: pageNo, sortBy: sortBy })
    }
  }
  const onSorting = (pagination, filter, sorter) => {
    setLoading(true)
    let data = sorter?.order ? sorter : ''
    setSortBy(data)
    fetchJobRoles({ sortBy: data, searchValue: searchValue })
  }

  return (
    <>
      <StyledTableSqare
        columns={columns}
        dataSource={data}
        pagination={false}
        onChange={onSorting}
        rowKey={record => record.id}
        loading={loading}
        scroll={{
          x: '1300px',
        }}
        bordered
        locale={{
          emptyText: (
            <EmptyWrapper center isSpin={loading}>
              <Empty
                image={NoInterview}
                imageStyle={{ height: 360 }}
                description={<span>No Job Role Available</span>}
              />
            </EmptyWrapper>
          ),
        }}
      />
      {!!totalPages && (
        <Pagination
          onChange={onPageChange}
          totalPages={totalPages}
          pageSize={10}
          current={page + 1}
        />
      )}

      <Drawer
        width="40%"
        title={'Schedule'}
        placement="right"
        closable={true}
        visible={openDrawer}
        content={content()}
        footer={footer()}
        onClose={() => setOpenDrawer(false)}
      />
      <Drawer
        width="40%"
        title={'About Company'}
        placement="right"
        closable={true}
        visible={openCompanyDrawer}
        content={content()}
        footer={footer()}
        onClose={() => {
          setOpenCompanyDrawer(false)
          setCorporateData('')
          setInstituteData('')
        }}
      />
    </>
  )
}

export default Table
